// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // Initialize Firebase
  firebaseConfig: {
    apiKey: "AIzaSyDU3DlRDQGGz5zjCo5ZDm7z893ny3HBlfc",
    authDomain: "recaudoapp.firebaseapp.com",
    databaseURL: "https://recaudoapp.firebaseio.com",
    projectId: "recaudoapp",
    storageBucket: "recaudoapp.appspot.com",
    messagingSenderId: "359126977312",
    appId: "1:359126977312:web:500707a5305f671350a545"
  }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
